import {action, isObservable, toJS} from "mobx";
import {Transport} from "data/transport";

declare var document:any;

export function getCookie(cookieName, shouldDelete?:boolean) {
	let cookie = {};
	document.cookie.split(';').forEach(function(el) {
		let [key,value] = el.split('=');
		cookie[key.trim()] = value;
	})
	const value = cookie[cookieName];
	if(shouldDelete) {
		deleteCookie(cookieName);
	}
	return value;
}

export function deleteCookie(cookieName) {
	document.cookie = cookieName+"=; path=/; domain=.well-concepts.com; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export function GET_QUERY(url) {
 return {
	 dataType:'json',
	 type:'GET',
	 contentType:"application/json; charset=utf-8",
	 headers: {'Authorization':'Token '+localStorage.getItem('token') },
	 url: Transport.URL(url),
 };
}

export function POST_QUERY(url, jsonData) {
 return {
	 dataType:'json',
	 type:'POST',
	 contentType:"application/json; charset=utf-8",
	 headers: {'Authorization':'Token '+localStorage.getItem('token') },
	 url: Transport.URL(url),
	 data:JSON.stringify(jsonData),
 };
}

export function POSTMULTIPART_QUERY(url, formData) {
	if(formData) {
		return {
			type:'POST',
			data: formData,
			processData: false,
			contentType: false,
			headers: {'Authorization':'Token '+localStorage.getItem('token') },
			url:Transport.URL(url),
		};
	} else {
    return null;
  }
}

export function PUT_QUERY(url, jsonData) {
 return {
	 type:'PUT',
	 contentType:"application/json; charset=utf-8",
	 headers: {'Authorization':'Token '+localStorage.getItem('token') },
	 url: Transport.URL(url),
	 data:JSON.stringify(jsonData),
 };
}

export function DELETE_QUERY(url) {
 return {
	 type:'DELETE',
	 contentType:"application/json; charset=utf-8",
	 headers: {'Authorization':'Token '+localStorage.getItem('token') },
	 url: Transport.URL(url),
 };
}

export function stringOrEmptyString(val) {
	//console.log("stringOrEmptyString");
	if(!val || val.length==0) {
		return "";
	} else {
		if(isObservable(val)) {
			//console.log("isObservable ", toJS(val));
			return toJS(val);
		} else {
			return val;
		}
	}
}

export function isEmpty(val:string|null|undefined) {
	return undefined===val || null===val || 0===val.length;
}

// export function isValidEmail(email:string):boolean {
// 	if(!email) {
// 		return false;
// 	}
// 	// Make sure email is valid
// 	// var re=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
// 	var re = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/i;
// 	return re.test(email);
// }

export function isValidPassword(password:string):boolean {
	return undefined !== password && null !== password && password.length >= 8 && null!=password.match(/[0-9]/);
}

export function getUrlParameter(sParam:string) {
	const sPageURL = window.location.search.substring(1);
	const sURLVariables = sPageURL.split('&');
	let sParameterName;
	let i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');
		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
		}
	}
	return '';
}

export function stripHtml(html) {
	const div = document.createElement("div");
	div.innerHTML = html;
	return div.textContent || "";
}


/*export function dataURItoBlob(dataURI, type?:string) {
	const byteString = atob(dataURI.split(',')[1]);
	const ab = new ArrayBuffer(byteString.length);
	const ia = new Uint8Array(ab);
	for (let i = 0; i < byteString.length; i++) { ia[i] = byteString.charCodeAt(i); }
	return new Blob([ab], { type: type?type:'image/png' });
}*/
/*
function dataURItoBlob(dataURI) {
	// convert base64/URLEncoded data component to raw binary data held in a string
	var byteString;
	if (dataURI.split(',')[0].indexOf('base64') >= 0) {
		byteString = atob(dataURI.split(',')[1]);
	} else {
		byteString = unescape(dataURI.split(',')[1]);
	}
	// separate out the mime component
	var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

	// write the bytes of the string to a typed array
	var ia = new Uint8Array(byteString.length);
	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}

	return new Blob([ia], {type:mimeString});
}
*/
export function dataURItoBlob(dataURI) {
	var binary = atob(dataURI.split(',')[1]);
	var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

	var array = [];
	for(var i = 0; i < binary.length; i++) {
		// @ts-ignore
		array.push(binary.charCodeAt(i));
	}
	return new Blob([new Uint8Array(array)], {type: mimeString});
}

export function handleSpacePressed(e, fn, ...args) {
	if (e.key === " " || e.key === 'Enter') {
		fn(...args);
		e.stopPropagation();
		e.preventDefault();
	}
}

export function resizeImage(imageFile, displayWidth) {
	// double the final requested width for higher resolution results
	const finalWidth = displayWidth*2;
	return new Promise((resolve, reject)=>{
		const reader = new FileReader();
		reader.onload = action((e) => {
			const img = new Image();//create a image
			if(e.target) {
				// @ts-ignore
				img.src = e.target.result; //result is base64-encoded Data URI

				// https://stackoverflow.com/questions/19262141/resize-image-with-javascript-canvas-smoothly
				img.onload = (e2) => {
					var canvas = document.createElement('canvas'),
							ctx = canvas.getContext("2d"),
							oc = document.createElement('canvas'),
							octx = oc.getContext('2d');

					canvas.width = finalWidth; // destination canvas size
					canvas.height = canvas.width * img.height / img.width;

					var cur = {
						width: Math.floor(img.width * 0.5),
						height: Math.floor(img.height * 0.5)
					}

					oc.width = cur.width;
					oc.height = cur.height;

					octx.drawImage(img, 0, 0, cur.width, cur.height);

					while (cur.width * 0.5 > finalWidth) {
						cur = {
							width: Math.floor(cur.width * 0.5),
							height: Math.floor(cur.height * 0.5)
						};
						octx.drawImage(oc, 0, 0, cur.width * 2, cur.height * 2, 0, 0, cur.width, cur.height);
					}

					ctx.drawImage(oc, 0, 0, cur.width, cur.height, 0, 0, canvas.width, canvas.height);
					const image = ctx.canvas.toDataURL( imageFile.type, 1);
					resolve(image);

					// if(e2.target) {
					// 	const elem = document.createElement('canvas');//create a canvas
					// 	//scale the image to 600 (width) and keep aspect ratio
					// 	// @ts-ignore
					// 	const scaleFactor = (displayWidth*2) / e2.target.width;
					// 	elem.width = (displayWidth*2);
					// 	// @ts-ignore
					// 	elem.height = e2.target.height * scaleFactor;
					//
					// 	//draw in canvas
					// 	const ctx = elem.getContext('2d');
					//
					// 	// @ts-ignore
					// 	ctx.drawImage(e2.target, 0, 0, elem.width, elem.height);
					//
					// 	const image = ctx.canvas.toDataURL( imageFile.type, 1);
					//
					// 	// send back the resized image
					// 	resolve(image);
					//
					// } else {
					// 	reject('img onload event had no target.');
					// }
				}
			} else {
				reject('Reader onload event had no target.');
			}
		});
		reader.readAsDataURL(imageFile);
	});
}


